import { useContext } from "react";
import { GlobalIcon } from "get-life-storybook-ts";
import { I18nContext } from "../../../../../../context/i18n.context";
import { PricingI } from "../../../../../../api/request/Lead/Interfaces/PricingInterface";
import numberFormat from "../../../../../../utils/Utils";
import { priceUpdatingText } from "../pricing/dashboardPrice";
import { cardStyle, sectionTitleStyle } from "../cardStyles";

interface UpcomingChargeCardProps {
  frequency: string;
  hasPromo: boolean;
  /** null = sin prima (cohorte SCOR FR): se pinta el texto neutro, nunca un importe. */
  regularPrice: number | null;
  displayPrice: number | null;
  nextPaymentDate?: string;
  pricing?: PricingI;
  onShowConditions: () => void;
}

const formatFullDate = (dateStr?: string) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  return d.toLocaleDateString("es-ES", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

const UpcomingChargeCard = ({
  frequency,
  hasPromo,
  regularPrice,
  displayPrice,
  nextPaymentDate,
  pricing,
  onShowConditions,
}: UpcomingChargeCardProps) => {
  const {
    state: { translate, langCode },
  } = useContext(I18nContext);

  return (
    <div style={cardStyle}>
      <div style={sectionTitleStyle}>
        <GlobalIcon iconName="CurrencyEuroIcon" size="XS" color="#4f46e5" />
        <h2 style={{ fontSize: 18, fontWeight: 700, color: "#111827", margin: 0 }}>
          {translate("newDashboard.billing.upcomingCharge")}
        </h2>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 16,
          padding: 20,
          backgroundColor: "#eef2ff",
          borderRadius: 10,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 48,
            height: 48,
            backgroundColor: "#4f46e5",
            borderRadius: 12,
            flexShrink: 0,
          }}
        >
          <GlobalIcon iconName="CurrencyEuroIcon" size="XS" color="#fff" />
        </div>
        <div>
          <p style={{ fontSize: 13, fontWeight: 500, color: "#6366f1", margin: "0 0 4px" }}>
            {translate(
              frequency === "MONTHLY"
                ? "newDashboard.monthlyFee"
                : "newDashboard.yearlyFee"
            )}
          </p>
          {null === displayPrice ? (
            <p data-testid="price-updating" style={{ fontSize: 18, fontWeight: 600, color: "#6b7280", margin: "4px 0 0" }}>
              {priceUpdatingText(translate, langCode)}
            </p>
          ) : hasPromo && null !== regularPrice ? (
            <div style={{ display: "flex", alignItems: "baseline", gap: 8, flexWrap: "wrap" }}>
              <span style={{ fontSize: 16, color: "#9ca3af", textDecoration: "line-through" }}>
                {numberFormat(regularPrice, "price")}
              </span>
              <span style={{ fontSize: 28, fontWeight: 800, color: "#312e81" }}>
                {numberFormat(displayPrice, "price")}
              </span>
            </div>
          ) : (
            <p style={{ fontSize: 28, fontWeight: 800, color: "#312e81", margin: 0 }}>
              {numberFormat(displayPrice, "price")}
            </p>
          )}
          {pricing?.promotion && pricing?.showPromo && null !== displayPrice && (
            <button
              onClick={onShowConditions}
              style={{
                border: "none",
                background: "none",
                cursor: "pointer",
                color: "#4f46e5",
                fontSize: 13,
                fontWeight: 500,
                padding: 0,
                marginTop: 4,
              }}
              onMouseEnter={(e) => { e.currentTarget.style.textDecoration = "underline"; }}
              onMouseLeave={(e) => { e.currentTarget.style.textDecoration = "none"; }}
            >
              {translate("newDashboard.promotion")}
            </button>
          )}
          {nextPaymentDate && (
            <p style={{ fontSize: 13, color: "#6366f1", margin: "6px 0 0" }}>
              {translate("newDashboard.billing.chargeDate").replace(
                "{date}",
                formatFullDate(nextPaymentDate)
              )}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default UpcomingChargeCard;
